//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('sourcesModal', {
    bindings: {
      close: '&',
      filterKey: '<',
      filterOptions: '<',
      defaultInstagramAccount: '<',
    },
    template: require('@legacy-components/content/sources-modal/sources-modal.html'),
    controller: [
      '$filter',
      '$window',
      'COLLECTION_SETTINGS',
      'CONTENT_LIBRARY_SOURCES_GROUPS',
      'SearchFilterService',
      'SEARCH_FILTERS',
      'TrackingService',
      function(
                $filter,
                $window,
                COLLECTION_SETTINGS,
                CONTENT_LIBRARY_SOURCES_GROUPS,
                SearchFilterService,
                SEARCH_FILTERS,
                TrackingService,
            ) {
        const self = this;
        const FILTER_SET_NAME = SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS;
        self.FILTER_SET_NAME = FILTER_SET_NAME;

        const ALL_SOURCES_GROUPS = [
          CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_USERS,
          CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_HASHTAGS,
          CONTENT_LIBRARY_SOURCES_GROUPS.TEAM_MEDIA,
        ];
        const TRACKING_CATEGORY = TrackingService.CATEGORY_LIBRARY;

        const contentGroupForFilterKey = {};
        contentGroupForFilterKey[COLLECTION_SETTINGS.FILTERS.TRACKED_USER_IDS] = CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_USERS;
        contentGroupForFilterKey[COLLECTION_SETTINGS.FILTERS.TRACKED_HASHTAGS] = CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_HASHTAGS;
        contentGroupForFilterKey[COLLECTION_SETTINGS.FILTERS.TRACKED_COMPETITOR_IDS] = CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_COMPETITORS;
        contentGroupForFilterKey[COLLECTION_SETTINGS.FILTERS.CURALATE_USER_IDS] = CONTENT_LIBRARY_SOURCES_GROUPS.TEAM_MEDIA;

        const mySourcesGroupsValue = function() {
          return contentGroupForFilterKey[self.filterKey];
        };

        const otherSourcesGroups = function() {
          return _(ALL_SOURCES_GROUPS).reject((sourcesGroups) => {
            return sourcesGroups === mySourcesGroupsValue();
          });
        };

        self.sourceSearchText = '';

        let isSourcesGroupSelected;
        let isAllMediaSelected;

        self.manageTeam = function() {
          $window.open('/account-settings/users', '_blank');
        };

        const hasAnyUncheckedOptions = function() {
          return _(self.sourceOptions).chain().where({ checked: false }).size().value() > 0;
        };

        const removeMySourcesGroup = function() {
          const sourcesGroupsValue = mySourcesGroupsValue();
          SearchFilterService.removeFilterValue(FILTER_SET_NAME, COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS, sourcesGroupsValue);
        };

        const removeAllMediaAndCheckOtherSourcesGroups = function() {
          SearchFilterService.removeFilterValue(
                        FILTER_SET_NAME,
                        COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
                        CONTENT_LIBRARY_SOURCES_GROUPS.ALL_MEDIA,
                    );
                    // if we're unchecking all media, go check all other sourcesGroups besides our own
          const sourcesGroupsValuesToAdd = otherSourcesGroups();
          _(sourcesGroupsValuesToAdd).each((sourcesGroupsValue) => {
            SearchFilterService.addFilterValue(
                            FILTER_SET_NAME,
                            COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
                            sourcesGroupsValue,
                        );
          });
                    // check account mentions because this isn't nested under an ALL sources group right now
          if (self.defaultInstagramAccount) {
            SearchFilterService.addFilterValue(
                            FILTER_SET_NAME,
                            COLLECTION_SETTINGS.FILTERS.ACCOUNT_MENTION_IDS,
                            self.defaultInstagramAccount.accountId,
                        );
          }
        };

        self.saveChanges = function() {
          const filterValues = _(self.sourceOptions).where({ checked: true });
          const anyUncheckedOptions = hasAnyUncheckedOptions();
          if (isSourcesGroupSelected && anyUncheckedOptions) {
            if (isAllMediaSelected) {
              removeAllMediaAndCheckOtherSourcesGroups();
            } else {
              removeMySourcesGroup();
            }
          }

          if (self.filterKey === 'trackedUserIds') {
            const businessFilterValues = _(filterValues).where({ isTrackedBusinessUser: true });
            const regularFilterValues = _(filterValues).where({ isTrackedBusinessUser: false });

            SearchFilterService.setFilter(FILTER_SET_NAME, self.filterKey, _(regularFilterValues).pluck('id'));
            SearchFilterService.setFilter(
                            FILTER_SET_NAME,
                            COLLECTION_SETTINGS.FILTERS.TRACKED_BUSINESS_USER_IDS,
                            _(businessFilterValues).pluck('id'),
                        );
          } else {
            SearchFilterService.setFilter(FILTER_SET_NAME, self.filterKey, _(filterValues).pluck('id'));
          }
          self.close({ changesApplied: true });
        };

        const getContentGroupSelected = function(setObject) {
          const currentSourcesGroup = mySourcesGroupsValue();
          const sourcesGroups = _(setObject).safeGet(COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS);
          isAllMediaSelected = _(sourcesGroups).contains(CONTENT_LIBRARY_SOURCES_GROUPS.ALL_MEDIA);
          return _(sourcesGroups).contains(currentSourcesGroup) || isAllMediaSelected;
        };

        self.trackSearch = _.debounce(() => {
          TrackingService.recordEvent(TRACKING_CATEGORY, TrackingService.ACTION_COLLECTIONS_SEARCH_SOURCES, 'View All Modal');
        }, 1000);

        this.$onInit = function() {
          const filterSet = SearchFilterService.getRegisteredSet(FILTER_SET_NAME);
          const filterValue = filterSet.params;
          const selectedSources = self.filterKey === 'trackedUserIds'
            ? _(filterValue[self.filterKey] || []).union(filterValue.trackedBusinessUserIds || [])
            : filterValue[self.filterKey] || [];
          isSourcesGroupSelected = getContentGroupSelected(filterValue);
          self.sourceOptions = _(self.filterOptions).map((filterOption) => {
            let description;
            let descriptionHtml;

            return {
              id: filterOption.id,
              name: filterOption.name,
              description,
              descriptionHtml,
              isTrackedBusinessUser: !!filterOption.isTrackedBusinessUser,
              searchString: filterOption.name + (description || ''),
              checked: _(selectedSources).contains(filterOption.id) || isSourcesGroupSelected,
              showDeprecationWarning: filterOption.userDetails && !filterOption.userDetails.isBusiness,
            };
          });
        };
      },
    ],
  });
})();
